<template>
    <div class="ourTeam">
        <div class="section">
            <div class="container is-fluid">
                <div class="tile is-ancestor">
                    <div class="tile is-vertical">
                        <div class="tile">
                            <div class="tile is-parent is-3 is-vertical">
                                <div class="columns">
                                    <div class="column">
                                        <h1 class="deneme">EKİBİMİZ</h1>
                                    </div>
                                </div>
                            </div>
                            <div class="tile is-parent is-vertical">
                                <div class="tile is-child  has-text-right is-size-1"><h2>KURUCU ORTAKLAR</h2></div>
                                <div class="tile columns">
                                    <div class="column">
                                        <div class="card">
                                            <div class="card-image">
                                                <figure class="image ">

                                                </figure>
                                            </div>
                                            <div class="card-content">
                                                <div class="media">
                                                    <div class="media-content">
                                                        <p @click="toggle" class="title is-4">Burçak Sercan Sarıkaya</p>
                                                        <p class="subtitle is-6">sarikaya@sarikayasahin.com</p>
                                                    </div>
                                                </div>
                                                <div class="modal" v-bind:class="{ active: isActive }">
                                                    <div class="modal-background"></div>
                                                    <div class="modal-content">
                                                        <div class="section">
                                                            <div class="contianer">
                                                                <div class="columns">
                                                                    <div class="column is-one-quarter">
                                                                        <img src="/static/burcakSarikaya.jpg">
                                                                    </div>
                                                                    <div class="column">
                                                                        <h1>Burçak Sercan Sarıkaya</h1><br>
                                                                        <h3>EĞİTİM</h3>
                                                                        <ul>
                                                                            <li>Atılım Üniversitesi Sosyal Bilimler Enstitüsü (İşletme Doktora Programı – Tam Burslu, devam etmekte)
                                                                            </li>
                                                                            <li>Bahçeşehir Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Tezli Yüksek Lisans Programı – Tam Burslu)
                                                                            </li>
                                                                            <li>Ankara Üniversitesi Hukuk Fakültesi (Lisans) </li>
                                                                        </ul>
                                                                        <br>
                                                                        <h3>ÜYELİKLER</h3>
                                                                        <ul>
                                                                            <li>ELSA</li>
                                                                        </ul>
                                                                        <br>
                                                                        <h3>YABANCI DİL</h3>
                                                                        <ul>
                                                                            <li>İngilizce</li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button class="modal-close is-large" @click="toggle" aria-label="close"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column">
                                        <div class="card">
                                            <div class="card-image">
                                                <figure class="image ">

                                                </figure>
                                            </div>
                                            <div class="card-content">
                                                <div class="media">
                                                    <div class="media-content">
                                                        <p @click="toggle2" class="title is-4">Onur Şahin</p>
                                                        <p class="subtitle is-6">sahin@sarikayasahin.com</p>
                                                    </div>
                                                </div>

                                                <div class="modal" v-bind:class="{ active: isActive2 }">
                                                    <div class="modal-background"></div>
                                                    <div class="modal-content">
                                                        <div class="section">
                                                            <div class="contianer">
                                                                <div class="columns">
                                                                    <div class="column is-one-quarter">
                                                                        <img src="/static/onurSahin.jpg">
                                                                    </div>
                                                                    <div class="column">
                                                                        <h1>Onur Şahin</h1><br>
                                                                        <h3>EĞİTİM</h3>
                                                                        <ul>
                                                                            <li>Galatasaray Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Doktora Programı, devam etmekte)
                                                                            </li>
                                                                            <li>Galatasaray Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Tezli Yüksek Lisans Programı)
                                                                            </li>
                                                                            <li>
                                                                                Glasgow Üniversitesi Hukuk Fakültesi (Fikri Mülkiyet ve Dijital Ekonomi Tezli Yüksek Lisans Programı – Avrupa Birliği Jean Monnet Bursu ile)
                                                                            </li>
                                                                            <li>Ankara Üniversitesi Hukuk Fakültesi (Lisans) </li>
                                                                            <li>Passau Üniversitesi Hukuk Fakültesi </li>
                                                                        </ul>
                                                                        <br>
                                                                        <h3>ÜYELİKLER</h3>
                                                                        <ul>
                                                                            <li>Marka Vekili </li>
                                                                            <li>Patent Vekili </li>
                                                                        </ul>
                                                                        <br>
                                                                        <h3>Yabancı Dil</h3>
                                                                        <ul>
                                                                            <li>İngilizce</li>
                                                                            <li>Almanca</li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button class="modal-close is-large" @click="toggle2" aria-label="close"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tile is-child  has-text-right is-size-1"><h2>AVUKATLAR</h2></div>
                                <div class="tile columns">
                                    <div class="column">
                                        <div class="card">
                                            <div class="card-image">
                                                <figure class="image ">

                                                </figure>
                                            </div>
                                            <div class="card-content">
                                                <div class="media">
                                                    <div class="media-content">
                                                        <p @click="toggle3" class="title is-4">Ali Rıza Aksoy</p>
                                                        <p class="subtitle is-6">aksoy@sarikayasahin.com</p>
                                                    </div>
                                                </div>
                                                <div class="modal" v-bind:class="{ active: isActive3 }">
                                                    <div class="modal-background"></div>
                                                    <div class="modal-content">
                                                        <div class="section">
                                                            <div class="contianer">
                                                                <div class="columns">
                                                                    <div class="column is-one-quarter">
                                                                        <img src="/static/aliRiza.jpg">
                                                                    </div>
                                                                    <div class="column">
                                                                        <h1>Ali Rıza Aksoy</h1><br>
                                                                        <h3>EĞİTİM</h3>
                                                                        <ul>
                                                                            <li>Ankara Üniversitesi Hukuk Fakültesi (Lisans)</li>
                                                                        </ul>
                                                                        <br>
                                                                        <h3>ÜYELİKLER</h3>
                                                                        <ul>
                                                                            <li>ELSA</li>
                                                                        </ul>
                                                                        <br>
                                                                        <h3>YABANCI DİL</h3>
                                                                        <ul>
                                                                            <li>İngilizce </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button class="modal-close is-large" @click="toggle3" aria-label="close"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column">
                                        <div class="card">
                                            <div class="card-image">
                                                <figure class="image ">

                                                </figure>
                                            </div>
                                            <div class="card-content">
                                                <div class="media">

                                                    <div class="media-content">
                                                        <p @click="toggle4" class="title is-4">Halil Çolak</p>
                                                        <p class="subtitle is-6">colak@sarikayasahin.com</p>
                                                    </div>
                                                </div>
                                                <div class="modal" v-bind:class="{ active: isActive4 }">
                                                    <div class="modal-background"></div>
                                                    <div class="modal-content">
                                                        <div class="section">
                                                            <div class="contianer">
                                                                <div class="columns">
                                                                    <div class="column is-one-quarter">
                                                                        <img src="/static/halil.jpg">
                                                                    </div>
                                                                    <div class="column">
                                                                        <h1>Halil Çolak</h1><br>
                                                                        <h3>EĞİTİM</h3>
                                                                        <ul>
                                                                            <li>Ankara Üniversitesi Hukuk Fakültesi (Lisans)</li>
                                                                        </ul>
                                                                        <br>
                                                                        <h3>YABANCI DİL</h3>
                                                                        <ul>
                                                                            <li>İngilizce</li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button class="modal-close is-large" @click="toggle4" aria-label="close"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column">
                                        <div class="card">
                                            <div class="card-image">
                                                <figure class="image ">

                                                </figure>
                                            </div>
                                            <div class="card-content">
                                                <div class="media">

                                                    <div class="media-content">
                                                        <p @click="toggle5" class="title is-4">Hüseyin Alp İlker</p>
                                                        <p class="subtitle is-6">ilker@sarikayasahin.com</p>
                                                    </div>
                                                </div>
                                                <div class="modal" v-bind:class="{ active: isActive5 }">
                                                    <div class="modal-background"></div>
                                                    <div class="modal-content">
                                                        <div class="section">
                                                            <div class="contianer">
                                                                <div class="columns">
                                                                    <div class="column is-one-quarter">
                                                                        <img src="/static/alp.jpg">
                                                                    </div>
                                                                    <div class="column">
                                                                        <h1>Hüseyin Alp İlker</h1><br>
                                                                        <h3>EĞİTİM</h3>
                                                                        <ul>
                                                                            <li>Galatasaray Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Tezli Yüksek Lisans Programı) </li>
                                                                            <li>Ankara Üniversitesi Hukuk Fakültesi (Lisans) </li>
                                                                        </ul>
                                                                        <br>
                                                                        <h3>YABANCI DİL</h3>
                                                                        <ul>
                                                                            <li>İngilizce</li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button class="modal-close is-large" @click="toggle5" aria-label="close"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tile columns">
                                    <div class="column">
                                        <div class="card">
                                            <div class="card-image">
                                                <figure class="image ">

                                                </figure>
                                            </div>
                                            <div class="card-content">
                                                <div class="media">

                                                    <div class="media-content">
                                                        <p @click="toggle7" class="title is-4">Rafet Emin Demir</p>
                                                        <p class="subtitle is-6">demir@sarikayasahin.com</p>
                                                    </div>
                                                </div>
                                                <div class="modal" v-bind:class="{ active: isActive7 }">
                                                    <div class="modal-background"></div>
                                                    <div class="modal-content">
                                                        <div class="section">
                                                            <div class="contianer">
                                                                <div class="columns">
                                                                    <div class="column is-one-quarter">
                                                                        <img src="/static/rafet.png">
                                                                    </div>
                                                                    <div class="column">
                                                                        <h1>Rafet Emin Demir</h1><br>
                                                                        <h3>EĞİTİM</h3>
                                                                        <ul>
                                                                            <li>Galatasaray Üniversitesi Sosyal Bilimler Enstitüsü (Özel Hukuk Tezli Yüksek Lisans Programı) </li>
                                                                            <li>Ankara Üniversitesi Hukuk Fakültesi (Lisans) </li>
                                                                        </ul>
                                                                        <br>

                                                                        <h3>YABANCI DİL</h3>
                                                                        <ul>
                                                                            <li>İngilizce</li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button class="modal-close is-large" @click="toggle7" aria-label="close"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column">
                                        <div class="card">
                                            <div class="card-image">
                                                <figure class="image ">

                                                </figure>
                                            </div>
                                            <div class="card-content">
                                                <div class="media">

                                                    <div class="media-content">
                                                        <p @click="toggle8" class="title is-4">Uğur Fırtına</p>
                                                        <p class="subtitle is-6">firtina@sarikayasahin.com</p>
                                                    </div>
                                                </div>
                                                <div class="modal" v-bind:class="{ active: isActive8 }">
                                                    <div class="modal-background"></div>
                                                    <div class="modal-content">
                                                        <div class="section">
                                                            <div class="contianer">
                                                                <div class="columns">
                                                                    <div class="column is-one-quarter">
                                                                        <img src="/static/ugur.png">
                                                                    </div>
                                                                    <div class="column">
                                                                        <h1>Uğur Fırtına </h1><br>
                                                                        <h3>EĞİTİM</h3>
                                                                        <ul>
                                                                            <li>Ankara Üniversitesi Hukuk Fakültesi (Lisans) </li>
                                                                        </ul>
                                                                        <br>
                                                                        <h3>YABANCI DİL</h3>
                                                                        <ul>
                                                                            <li>İngilizce</li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button class="modal-close is-large" @click="toggle8" aria-label="close"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tile is-child  has-text-right is-size-1"><h2>DANIŞMAN</h2></div>
                                <div class="tile colums">
                                    <div class="column is-half paddingless">
                                        <div class="card">
                                            <div class="card-image">
                                                <figure class="image ">

                                                </figure>
                                            </div>
                                            <div class="card-content">
                                                <div class="media">

                                                    <div class="media-content">
                                                        <p @click="toggle6" class="title is-4">Onur Uraz</p>
                                                        <p class="subtitle is-6">uraz@sarikayasahin.com</p>
                                                    </div>
                                                </div>
                                                <div class="modal" v-bind:class="{ active: isActive6 }">
                                                    <div class="modal-background"></div>
                                                    <div class="modal-content">
                                                        <div class="section">
                                                            <div class="contianer">
                                                                <div class="columns">
                                                                    <div class="column is-one-quarter">
                                                                        <img src="/static/onur.jpg">
                                                                    </div>
                                                                    <div class="column">
                                                                        <h1>Onur Uraz</h1><br>
                                                                        <h3>EĞİTİM</h3>
                                                                        <ul>
                                                                            <li>Southampton Üniversitesi (Uluslararası Ceza Hukuku Doktora Programı)</li>
                                                                            <li>Glasgow Üniversitesi (Ululararası Kamu Hukuku Yüksek Lisans Programı)</li>
                                                                            <li>Gazi Üniversitesi Hukuk Fakültesi (Lisans)</li>
                                                                        </ul>
                                                                        <br>
                                                                        <h3>ÜYELİKLER</h3>
                                                                        <ul>
                                                                            <li>Southampton Student Law Review Editörü (2017)</li>
                                                                            <li>Ankara Barosu Dergisi Yürütme Kurulu Üyesi (2012)</li>
                                                                            <li>International Association of Genocide Scholars </li>
                                                                            <li>European Society of International Law</li>
                                                                            <li>The Centre for Law, Policy and Society (Southampton University)</li>
                                                                        </ul>
                                                                        <br>
                                                                        <h3>YABANCI DİL</h3>
                                                                        <ul>
                                                                            <li>İngilizce</li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button class="modal-close is-large" @click="toggle6" aria-label="close"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'ekip',
        data() {
            return {
                isActive: false,
                isActive2: false,
                isActive3: false,
                isActive4: false,
                isActive5: false,
                isActive6: false,
                isActive7: false,
                isActive8: false
            }
        },
        methods: {
            toggle: function () {
                this.isActive = !this.isActive;
            },
            toggle2: function () {
                this.isActive2 = !this.isActive2;
            },
            toggle3: function () {
                this.isActive3 = !this.isActive3;
            },
            toggle4: function () {
                this.isActive4 = !this.isActive4;
            },
            toggle5: function () {
                this.isActive5 = !this.isActive5;
            },
            toggle6: function () {
                this.isActive6 = !this.isActive6;
            },
            toggle7: function () {
                this.isActive7 = !this.isActive7;
            },
            toggle8: function () {
                this.isActive8 = !this.isActive8;
            },
        },
        // mounted () {
        //     x = document.getElementsByClassName('extra');
        //     console.log(x);
        // }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .paddingless {
        padding-left: 0px;
        padding-right: 0px;
    }

    .ourTeam p {
        font-size: 1.2rem;
    }

    .ourTeam ul li {
        font-size: 1.2rem;
        color: white;
        list-style: disc;
    }

    #app {
        background: #606c96;
    }

    .ourTeam h1::after {
        content: "";
        position: absolute;
        height: 5px;
        bottom: 0;
        left: 0;
        width: 40%;
        background: #81A716;
    }

    .ourTeam h1, .ourTeam h2 {
        position: relative;
        color: #504f50;
        padding-top: 70px;
        font-family: 'SEC', sans-serif;
    }

    .active {
        display: flex;
    }

    .modal p {
        color: white;
    }

    .media-content .title {
        cursor: pointer;
    }

    .modal h1 {
        color: azure;
        font-family: 'SEC';
    }

    .modal h3 {
        color: gainsboro;
        text-transform: uppercase;
        font-size: 15px;
        font-family: SEC, sans-serif;
    }

    .modal .is-one-quarter::after {
        display: none;
    }

    .modal .is-one-quarter {
        padding-right: 27px;
    }

    .modal .is-one-quarter img {
        padding-top: 15px;
    }

    .content:not(:last-child) {
        margin-bottom: 0px;
    }

    .content {
        text-align: left;
    }

    .modal-content {
        width: 950px;
    }

    @media only screen and (max-width: 768px) {
        .ourTeam {
            margin-bottom: 100px;
        }

        .ourTeam h1 {
            font-size: 25px;
            padding-top: 0px;
        }

        div.tile.is-parent.is-3.is-vertical::after {
            content: "";
            position: absolute;
            right: 12%;
            top: 0;
            height: 100%;
            background: unset;
            width: 1px;
        }

        img {
            height: auto;
            max-width: 50%;
        }
    }

</style>



// WEBPACK FOOTER //
// ekip.vue?f1953010